module.exports = __webpack_public_path__ + "static/gilardi-zoom-257b516d6b4a794b484de009531285df.jpg";